export { default } from './otpCode';
